import { VerticalTabsStyled } from '@/components/VerticalTabs/styled';
import { Icon } from '@shopify/polaris';

interface ITab {
  id: string;
  label: string;
  prefixIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  suffixIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

interface IProps {
  tabs: ITab[];
  selected: string;
  onChange: (id: string) => void;
  style?: React.CSSProperties;
  className?: string;
}

const VerticalTabs = ({ tabs, selected, onChange, style, className }: IProps) => {
  return (
    <VerticalTabsStyled style={style} className={className}>
      {tabs.map((tab) => (
        <button
          className={`vertical-tab-item ${selected === tab.id ? 'selected' : ''}`}
          key={tab.id}
          onClick={() => {
            onChange(tab.id);
          }}
        >
          <div className="vertical-tab-item-label">
            {tab.prefixIcon && <Icon source={tab.prefixIcon} />}
            {tab.label}
          </div>
          {selected === tab.id && tab.suffixIcon && <Icon source={tab.suffixIcon} />}
        </button>
      ))}
    </VerticalTabsStyled>
  );
};

export default VerticalTabs;
